// @noflow
import type { Action, State } from './types';

const initialState: State = {
  // activeContent: {},
  startTime: '',
  endTime: '',
  channelSection: [],
  content: {
    available_count: 0,
    channel_airings: [],
  },
  fetchingAirings: false,
  fetchingChannels: false,
  fetchingLiveLinearChannelsError: false,
  liveLinearChannelsError: false,
  error: false,
  channels: {},
  channelError: false,
  channelList: [],
  channelListStale: false,
  fetchingLiveLinearChannels: false,
  liveLinearChannels: {
    available_count: 0,
    channel_airings: {},
  },
  activeContent: {
    available_count: 0,
    channel_airings: {},
  },
  openAiring: {},
  openChannel: {},
  openAiringId: '',
  expandedChannels: [],
  expandedChannelGroup: [],
  currentTime: null,
  currentTimeSelection: 'Today',
  currentFilter: 'All Channels',
  currentGuideType: 'all',
  currentSearchTerm: '',
  timerCreatedDisplay: false,
  showRecOptionsModal: false,
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'CHANGE_GUIDE_OPEN_AIRING':
      return {
        ...state,
        openAiring: action.airing,
      };
    case 'CHANGE_GUIDE_OPEN_CHANNEL':
      return {
        ...state,
        openChannel: action.channelInformation,
      };
    case 'CHANGE_GUIDE_OPEN_AIRING_ID':
      return {
        ...state,
        openAiringId: action.airingId,
      };
    case 'CHANGE_CURRENT_GUIDE_TIME':
      return {
        ...state,
        currentTime: action.time,
      };
    case 'CHANGE_CURRENT_GUIDE_TIME_SELECTION':
      return {
        ...state,
        currentTimeSelection: action.time,
      };
    case 'CHANGE_CURRENT_GUIDE_FILTER':
      return {
        ...state,
        currentFilter: action.filter,
        content: {
          available_count: 0,
          channel_airings: [],
        },
      };
    case 'CHANGE_CURRENT_GUIDE_SEARCH':
      return {
        ...state,
        currentSearchTerm: action.searchTerm,
      };
    case 'CHANGE_CURRENT_GUIDE_TYPE':
      return {
        ...state,
        currentGuideType: action.guideType,
      };
    case 'REQUEST_GUIDE_AIRINGS':
      return {
        ...state,
        fetchingAirings: true,
      };
    case 'RECEIVE_GUIDE_AIRINGS': {
      const { payload, concatRows, startTime, endTime } = action;
      const newChannelAirings =
        concatRows && state.content.channel_airings
          ? state.content.channel_airings.concat(payload.channel_airings)
          : payload.channel_airings;

      return {
        ...state,
        content: {
          ...payload,
          channel_airings: newChannelAirings,
        },
        fetchingAirings: false,
        error: false,
        startTime,
        endTime,
      };
    }
    case 'RECEIVE_GUIDE_AIRINGS_ERROR': {
      return {
        ...state,
        fetchingAirings: false,
        error: true,
      };
    }
    case 'REQUEST_SINGULAR_AIRING': {
      return {
        ...state,
      };
    }
    case 'RECEIVE_SINGULAR_AIRING': {
      const { payload } = action;

      return {
        ...state,
        openAiring: payload,
      };
    }
    case 'REQUEST_ALL_CHANNELS':
      return {
        ...state,
        fetchingChannels: true,
      };
    case 'RECEIVE_ALL_CHANNELS': {
      const { payload, channelList } = action;
      return {
        ...state,
        fetchingChannels: false,
        channelListStale: false,
        channels: payload,
        channelList,
      };
    }
    case 'RECEIVE_ALL_CHANNELS_ERROR':
      return {
        ...state,
        fetchingChannels: false,
        channelError: true,
      };
    // FIXME: Nick, Alan and Kyle - its up to you, to add proper handling for the following actions (they were just missing)
    case 'REQUEST_ADD_FAVORITE': {
      return { ...state };
    }
    case 'ADD_FAVORITE_SUCCESS': {
      return { ...state };
    }
    case 'ADD_FAVORITE_ERROR': {
      return { ...state };
    }
    case 'REQUEST_DELETE_FAVORITE': {
      return { ...state };
    }
    case 'DELETE_FAVORITE_SUCCESS': {
      const { currentFilter, channel: channelId } = action.payload;
      const {
        available_count: availableCount,
        channel_airings: channelAiring,
        channels,
      } = state.content;
      if (currentFilter === 'Favorites') {
        const newChannels = [...channels];
        const newChannelAirings = [...channelAiring];
        // eslint-disable-next-line camelcase
        const channelIndex = channelAiring.findIndex(
          channel => channel.channel_information?.channel === channelId,
        );
        if (channelIndex > -1) {
          newChannels.splice(
            newChannels.indexOf(channelAiring[channelIndex].channel_information.padded),
            1,
          );
          newChannelAirings.splice(channelIndex, 1);
        }
        return {
          ...state,
          content: {
            ...state.content,
            available_count: availableCount - 1,
            channels: newChannels,
            channel_airings: newChannelAirings,
          },
        };
      }

      return { ...state };
    }
    case 'DELETE_FAVORITE_ERROR': {
      return { ...state };
    }
    case 'CHANGE_ACTIVE_RECEIVER_SUCCESS':
      return {
        ...state,
        fetchingChannels: false,
        channelError: false,
        channelListStale: state.channelList.length !== 0,
      };
    case 'SIGN_OUT':
      return {
        ...state,
        fetchingChannels: false,
        channelError: false,
        channelListStale: state.channelList.length !== 0,
        fetchingFavorites: false,
        favoritesFetched: false,
        favoritesError: false,
        favorites: {},
        fetchingLiveLinearChannels: false,
        liveLinearChannels: {
          available_count: 0,
          channel_airings: {},
        },
        currentTimeSelection: 'Today',
        currentFilter: 'All Channels',
      };
    case 'SHOW_TIMER_CONFIRMATION':
      return {
        ...state,
        timerCreatedDisplay: true,
      };
    case 'HIDE_TIMER_CONFIRMATION':
      return {
        ...state,
        timerCreatedDisplay: false,
      };
    case 'SHOW_REC_OPTIONS_MODAL':
      return {
        ...state,
        showRecOptionsModal: true,
      };
    case 'HIDE_REC_OPTIONS_MODAL':
      return {
        ...state,
        showRecOptionsModal: false,
      };
    case 'TOGGLE_EXPANDED_CHANNEL_GROUP': {
      const { channel } = action;
      const newExpandedChannels = [];
      const index = state.expandedChannels.indexOf(channel);
      const channelGroup = state.content.channel_airings.find(
        channelAiring => channelAiring.channel_information.channel === channel,
      );

      if (index === -1) {
        newExpandedChannels.push(channel);
      } else {
        newExpandedChannels.splice(index, 1);
      }
      return {
        ...state,
        expandedChannels: newExpandedChannels,
        expandedChannelGroup: channelGroup,
      };
    }
    default:
      /* Following line assures switch exhaustiveness */
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
